class TBImageCompare extends HTMLElement {
  connectedCallback () {
    this.range = this.querySelector('.image-compare__range')
    if (!this.range) return

    this.handleInput = () => {
      this.style.setProperty('--exposure', `${this.range.value}%`)
    }

    this.range.addEventListener('input', this.handleInput)
    this.handleInput()
  }

  disconnectedCallback () {
    if (this.range) this.range.removeEventListener('input', this.handleInput)
  }
}

if (!customElements.get('tb-image-compare')) {
  customElements.define('tb-image-compare', TBImageCompare)
}
